var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text",class:[_vm.className]},[_vm._v(" "+_vm._s(_vm.words)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }